/**
 * BitacoraCollapsedGroup Component (Tier C)
 *
 * Collapsed group entry for low-signal system changes (status changes, PO updates,
 * field edits) grouped by author+day. Shows a single summary line and expands to a
 * bullet list of humanized events.
 *
 * @module components/timeline/BitacoraCollapsedGroup
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import TaskAssigneeAvatar from '../tasks/shared/TaskAssigneeAvatar';
import { humanizeAction, formatRelativeTime } from '../../services/timelineService';

const BitacoraCollapsedGroup = ({ group }) => {
  const [expanded, setExpanded] = useState(false);

  const assignee = {
    id: group.user_id,
    full_name: group.user_name || 'Sistema',
  };

  const count = Array.isArray(group.events) ? group.events.length : 0;

  const toggleExpanded = () => setExpanded((v) => !v);

  return (
    <div className={`bitacora-group${expanded ? ' is-expanded' : ''}`}>
      <div className="bitacora-group-avatar">
        <TaskAssigneeAvatar assignee={assignee} size="sm" />
      </div>

      <div className="bitacora-group-body">
        <div className="bitacora-group-header">
          <span className="bitacora-group-summary">
            <strong>{group.user_name || 'Sistema'}</strong>
            <span className="bitacora-group-dot"> · </span>
            {formatRelativeTime(group.timestamp)}
            <span className="bitacora-group-dot"> · </span>
            hizo {count} {count === 1 ? 'cambio' : 'cambios'}
          </span>
          <button
            type="button"
            className="bitacora-group-toggle"
            onClick={toggleExpanded}
            aria-expanded={expanded}
          >
            <i className={`bi bi-chevron-${expanded ? 'up' : 'down'} me-1`}></i>
            {expanded ? 'ocultar' : 'ver'}
          </button>
        </div>

        <Collapse in={expanded}>
          <div>
            {expanded && (
              <ul className="bitacora-group-list">
                {group.events.map((event, idx) => (
                  <li key={event.id || `${group.user_id}-${idx}`}>
                    {humanizeAction(event)}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </Collapse>
      </div>
    </div>
  );
};

BitacoraCollapsedGroup.propTypes = {
  group: PropTypes.shape({
    kind: PropTypes.string,
    user_id: PropTypes.string,
    user_name: PropTypes.string,
    date: PropTypes.string,
    timestamp: PropTypes.string,
    events: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
};

export default BitacoraCollapsedGroup;
